import { Stepper, StepperChangeEvent } from '@progress/kendo-react-layout';
import styled from 'styled-components';
import { rem } from '../../../../style';
import MobileStepper from '../mobile-stepper';
import { CustomStepProps } from '../utils';

const StepContainer = styled.div`
  margin-right: ${rem(80)};

  .k-step-done .k-step-label {
    color: #007cb7 !important;
    text-decoration: underline !important;
    cursor: pointer;
    font-weight: 600;
  }
`;

export interface FormStepperSectionProps {
  currentStepIndex: number;
  steps: CustomStepProps[];
  moveToStepCall: Function;
}

const FormStepperSection = (p: FormStepperSectionProps) => {
  const { currentStepIndex, steps, moveToStepCall } = p;

  return (
    <>
      <MobileStepper
        className="d-flex d-lg-none"
        currentStepIndex={currentStepIndex}
        items={steps}
      />
      <StepContainer className="d-none d-lg-flex">
        <Stepper
          className="align-self-start"
          value={currentStepIndex}
          items={steps}
          orientation={'vertical'}
          onChange={(stepperChangeEvent: StepperChangeEvent) =>
            moveToStepCall(stepperChangeEvent)
          }
        />
      </StepContainer>
    </>
  );
};

export default FormStepperSection;
